import React, { Component } from 'react';
import PropTypes from 'prop-types';

// components
import { Image } from '../Image/Image';

// helper functions
import * as func from '../../helpers/bodyScrollStyle';

// styles
import './modal-video.scss';

class ModalVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      visual: false,
      scrollPosition: null
    };
    this.videoPlay = React.createRef();
  }

  playVideo = () => {
    this.setState(
      {
        playing: true,
        visual: true,
        scrollPosition: window.pageYOffset
      },
      () => {
        func.activate(this.state.scrollPosition);
      }
    );
    const playPromise = this.videoPlay.current.play();
    if (playPromise !== undefined) {
      playPromise
        .then(_ => {
          this.videoPlay.current.play();
        })
        .catch(error => {
          console.log('Error from play func:', error);
        });
    }
  };

  handleKeyDown = (e) => {
    if(e.keyCode === 13) {
      this.playVideo()
    }
  }

  resetVideo = () => {
    setTimeout(() => {
      this.setState({ playing: false, visual: false });
      this.videoPlay.current.load();
      func.deactivate(this.state.scrollPosition);
    }, 200);
  };

  closeVideo = () => {
    this.setState(() => {
      return { playing: false, visual: false };
    });
    setTimeout(() => {
      this.videoPlay.current.pause();
    }, 200);
    func.deactivate(this.state.scrollPosition);
  };

  render() {
    return (
      <figure className={this.props.className}>
        <div className="video__container">
          <div
            className={` modal-video ${this.state.visual ? 'visual' : ''}`}
            ref="modalVideo"
          >
            <div className="modal-video-body"> 
              <div
                aria-hidden={true}
                className={`modal-video-overlay ${
                  this.state.visual ? 'visual' : ''
                }`}
                onClick={this.closeVideo}
              />
              <div className="modal-video-inner">
                <div className="modal-video-movie-wrap">
                  <button
                    onClick={this.closeVideo}
                    aria-label='Close'
                  />
                  <video //eslint-disable-line
                    id={this.props.videoId}
                    onEnded={this.resetVideo}
                    ref={this.videoPlay}
                    data-video-source={this.props.video}
                    preload="none"
                    controls
                    controlsList="nodownload nofullscreen noremoteplayback"
                  >
                    <source src={this.props.video} type="video/mp4" />
                    Your browser can't play this video.
                  </video>
                </div>
              </div>
            </div>
          </div>

          <div className="video__image-container">
            <Image fluid={this.props.posterImage} />
            {!this.state.playing ? (
              <div
                aria-hidden={true}
                className="video__overlay"
                onClick={this.playVideo}
              >
                <div className="video__overlay-content">
                  <div
                    role='button'
                    tabIndex={0}
                    className="video__play-container"
                    onClick={this.playVideo}
                    onKeyDown={this.handleKeyDown}
                  >
                    <span>P</span>
                    <span>L</span>
                    <span className="video__play" />
                    <span>A</span>
                    <span>Y</span>
                  </div>
                </div>
              </div>
            ) : (
                <div
                  aria-hidden={true}
                  className="video__pause-overlay"
                  onClick={this.closeVideo} />
            )}
          </div>
        </div>
        <figcaption>{this.props.text}</figcaption>
      </figure>
    );
  }
}
export default ModalVideo;

ModalVideo.defaultProps = {
  posterImage: {},
  text: '',
  video: '',
  videoId: '',
  className: ''
};

ModalVideo.propTypes = {
  posterImage: PropTypes.object,
  text: PropTypes.string,
  className: PropTypes.string,
  video: PropTypes.any,
  videoId: PropTypes.string
};
